import { SizeField } from '../fields/size';
import { StopPriceField } from '../fields/stop_price';
import { OrderSliderField } from '../fields/order_slider';

export function StopMarketForm() {
  return (
    <>
      <StopPriceField fieldName="stopPrice" />
      <SizeField priceFieldName="stopPrice" />
      <OrderSliderField />
    </>
  );
}
